



















































































































import { Component, Vue } from "vue-property-decorator";
import { empresa } from "@/shared/dtos/empresa";
import { MessageService } from "@/shared/services/message-service";
import empresaModule from "@/store/modules/empresa-module";
import { singleOrDoubleRowClick } from "@/utils/dblclickrow";
@Component({
  components: { Xbtn: () => import("@/components/buttons/x-btn.vue") },
  $_veeValidate: { validator: "new" },
})
export default class EmpresasLista extends Vue {
  public search: string = "";
  public show_dialog: boolean = false;
  public obj_empresa: empresa = new empresa({ activo: true });
  public es_edicion: boolean = false;
  public created() {
    empresaModule.getempresas();
  }

  public get datasource() {
    return empresaModule.empresas;
  }

  public get headers() {
    return [
      {
        text: "Nombre",
        align: "start",
        value: "nombre",
      },
      { text: "Activo", value: "activo" },
      { text: "", value: "acciones", align: "end" },
    ];
  }

  /**
   * editar
   */
  public editar_rw(obj: empresa) {
    this.obj_empresa = new empresa(obj);
    this.es_edicion = true;
    this.show_dialog = true;
  }

  /**
   * add_new
   */
  public add_new() {
    this.$validator.reset();
    this.show_dialog = true;
  }

  /**
   *eliminar
   */
  public eliminar(obj: empresa) {
    MessageService.confirm(
      "¿Seguro que quiere eliminar " + obj.nombre + "?",
      "Eliminar",
      (x: boolean) => {
        if (x) {
          empresaModule
            .eliminarempresa(obj)
            .then(() => empresaModule.getempresas())
            .catch(() => {
              MessageService.toast(
                "No se ha podido eliminar, hay datos asociados a este proveedor",
                MessageService.TypeWarning
              );
            });
        }
      }
    );
  }

  /**
   * cancelar
   */
  public cancelar() {
    this.obj_empresa = new empresa({ activo: true });
    this.show_dialog = false;
    this.es_edicion = false;
  }

  /**
   * aceptar
   */
  public aceptar() {
    this.$validator.validateAll().then((allOk) => {
      if (allOk) {
        if (this.es_edicion) {
          empresaModule.modificarempresa(this.obj_empresa);
        } else {
          empresaModule.guardarempresa(this.obj_empresa);
        }
        this.cancelar();
      }
    });
  }
  public dblclick(item: any, singleClickFunc: any, doubleClickFunc: any) {
    singleOrDoubleRowClick(item, singleClickFunc, doubleClickFunc);
  }
}
